<template>
  <q-banner dense class="bg-warning text-white warning-banner">
    <div class="row items-center" :class="`justify-${align}`">
      <q-icon v-if="icon" :name="icon" :size="iconSize" class="q-mr-sm" />
      <div class="text-weight-bold" v-html="message"></div>
    </div>
  </q-banner>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  props: {
    message: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: undefined,
    },
    align: {
      type: String as PropType<'start' | 'center' | 'end'>,
      default: 'start',
    },
    iconSize: {
      type: String,
      default: 'xs',
    },
  },
})
</script>

<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';

.warning-banner {
  width: 100%;

  ::v-deep a {
    color: #d7e9aa;
    text-decoration: none;
  }
}
</style>
